module.exports = __webpack_public_path__ + "static/img/yddpos.808cff3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tab/yddpos.png
// module id = NKLb
// module chunks = 0